import React from 'react';

export const SkeletonTemplate7 = () => {
  const items = Array.from(Array(7).keys());

  return (
    <section className="vitrine-template7--layout-1" data-testid="skeleton">
      <div className="vitrine-template7__skeleton">
        <div className="vitrine-template7__skeleton--title" />
        <div className="vitrine-template7__skeleton--slider">
          <div className="vitrine-template7__skeleton--slider-buttons">
            <span className="vitrine-template7__skeleton--slider-button" />
            <span className="vitrine-template7__skeleton--slider-button" />
          </div>
          <div className="vitrine-template7__skeleton--cards">
            {items.map(value => (
              <div key={value} className="vitrine-template7__skeleton--card">
                <div className="vitrine-template7__skeleton--card--image" />
                <div className="vitrine-template7__skeleton--card--text">
                  <div className="vitrine-template7__skeleton--card--text--club" />
                  <div className="vitrine-template7__skeleton--card--text--title">
                    <span />
                    <span />
                  </div>
                  <div className="vitrine-template7__skeleton--card--text--description">
                    <span />
                    <span />
                    <span />
                  </div>
                  <div className="vitrine-template7__skeleton--card--text--benefits">
                    <span />
                    <span />
                    <span />
                  </div>
                  <div className="vitrine-template7__skeleton--card--text--date" />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="vitrine-template7__skeleton--dots">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </section>
  );
};
